export const SE_UI_DATE_FORMATS = {
    parse: {
        dateInput: 'LL',
    },
    display: {
        dateInput: 'LL',
        monthYearLabel: 'MMMM YYYY',
        dateA11yLabel: 'LL',
        monthYearA11yLabel: 'MMMM YYYY'
    },
};

export const SE_UI_DATAGRID_DATE_FORMATS = {
    parse: {
        dateInput: [],
    },
    display: {
        dateInput: '',
        monthYearLabel: 'MMMM YYYY',
        dateA11yLabel: 'LL',
        monthYearA11yLabel: 'MMMM YYYY'
    },
};

export const SE_UI_DATE_TIME_FORMATS = {
    parse: {
        dateInput: 'LL',
        timeInput: 'HH:mm'
    },
    display: {
        dateInput: 'LL',
        monthYearLabel: 'MM YYYY',
        dateA11yLabel: 'LL',
        monthYearA11yLabel: 'MMMM YYYY',
        timeInput: 'HH:mm',
        timeOptionLabel: 'HH:mm'
    },
};
